import React from "react";
import { useNavigate } from "react-router-dom";
import TemplateList from "../components/TemplateList";
import type { Template } from "../types/api";

const Templates: React.FC = () => {
  const navigate = useNavigate();

  const handleSelectTemplate = (template: Template) => {
    navigate("/video/template2v", {
      state: { template: template },
    });
  };

  return (
    <div className="bg-black min-h-screen p-6 pb-48 md:pb-24">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-white text-4xl font-bold mb-3">PixelMaker Templates</h1>
          <p className="text-white/70 text-lg">Upload an image of anyone and generate a video of them based on any template below</p>
        </div>
        <TemplateList onSelect={handleSelectTemplate} />
      </div>
    </div>
  );
};

export default Templates;
